export enum PaymentStatus {
  SUCCESS = "success",
  FAILURE = "failure",
  PROGRESS = "progress",
}

export const STATUS_REQUEST_INTERVAL = 3000; // in millis

export enum PaymentSource {
  SHIPMENTS = "shipmentList",
  ORDER = "orderFlow",
  RDL = "rdl",
}
